if (!customElements.get('refill-product-grid')) {
  customElements.define(
    'refill-product-grid',
    class RefillProductGrid extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.handleVariantChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleVariantChange);
      }

      handleVariantChange(event) {
        const colorInput = event.target.closest('[data-refill-variant-id]');
        if (!colorInput) return;

        const productItem = colorInput.closest('.refill-product-grid__item');
        const variantInput = productItem?.querySelector('product-form input[name="id"]');
        if (!variantInput) return;

        variantInput.value = colorInput.dataset.refillVariantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
